import moment from 'moment';
import template from './bVolumeSlicerTable.html';


export function bVolumeSlicerTableDirective() {
  'ngInject';
  return {
    restrict: 'E',
    template: template,
    controller: bVolumeSlicerTableController,
    controllerAs: 'bVolumeSlicerTable',
    bindToController: true,
    scope: {
      volumes: "=",
      valueAddedProcesses: "=",
      canShare: "=",
      onShareChart: "&",
      onExportChart: "&"
    }
  };
}

class bVolumeSlicerTableController {
  constructor($scope, $translate, $rootScope, $routeParams) {
    'ngInject';

    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$translate = $translate;
    this.$routeParams = $routeParams;
    this.title = this.$translate.instant('VIEW360.VOLUME_SLICER_TABLE');
    this.volumeTitle = this.$translate.instant('WORK.VOLUME');
    this.avgTimeUnit = this.$translate.instant('VIEW360.AVERAGE_TIME_PER_UNIT');
    this.datesRanges = [];
    this.allProcesses = {};
    this.processesNames = [];
    this.datesVolumesMap = {};
    this.processTimesSum = {};
    this.processVolSum = {};
    this.rowLimit = 10;
    this.showZero = false;
    this.selectedRows = {};
    this.volumesData = {selectedProcesses: []};
    this.timePerUnitData = {selectedProcesses: []};
    this.$scope.$watch(() => this.volumes, newValue => this.updateChart(newValue));
    this.$scope.$watch(() => this.showZero, () => this.filterData());
  }

  exportChart() {
    this.$rootScope.exportVolSlicerChart = this.volumes;
    this.onExportChart({exportData: {type: 'Volume'}});
  }

  hasSharedView(){
    return window.location.pathname.includes('shared');
  }

  setupShowZeroForSharedView(){
    if(this.hasSharedView()){
      this.showZero = this.$rootScope.dataVolSlicerChartshowZero;
    }
  }

  filterData() {
    const pNames = Object.keys(this.allProcesses).filter(pn => this.processTimesSum[pn] > 0);
    this.processesNames = this.showZero ? pNames : pNames.filter(pn => this.processVolSum[pn] > 0);
    this.processesNames = this.processesNames.sort((a, b) => {
      return this.processTimesSum[b] - this.processTimesSum[a];
    });
    this.$rootScope.dataVolSlicerChartshowZero = this.showZero;

  }

  getMonthShort(month) {
    return moment(month, 'YYYY-MM').format('MMM').toUpperCase();
  }

  getIconCls(value) {
    if (!value) {
      return;
    }

    const icon = ['fa'];
    const clsToPush = value.volume < value.prevVolume ? 'fa-caret-down' : value.volume > value.prevVolume ? 'fa-caret-up' : '';
    icon.push(clsToPush);
    return icon;
  }

  lessCount() {
    return this.processesNames.length && this.rowLimit > 10;
  }

  moreCount() {
    const moreCount = this.processesNames.length - this.rowLimit;
    return moreCount > 10 ? 10 : moreCount < 1 ? 0 : moreCount;
  }

  populateExportEvent(exportData) {
    this.onExportChart({exportData});
  }

  populateShareEvent(shareData) {
    this.onShareChart({shareData});
  }


  showLess() {
    let minusCount = this.rowLimit % 10;
    minusCount = minusCount === 0 ? 10 : minusCount;
    const lessCount = this.rowLimit - minusCount > 10 ? 10 : minusCount;
    this.rowLimit -= lessCount;
  }

  showMore() {
    this.rowLimit += 10;
  }

  shareChart() {
    const shareData = {type: 'vol_slicer_table'};
    this.onShareChart({shareData});
  }

  updateChart(newValue) {
    if (!newValue || !this.valueAddedProcesses) {
      return;
    }

    this.setupShowZeroForSharedView();

    this.rowLimit = 10;
    const volumes = newValue;
    // TODO: Delete mocks before production launch
    // const volumes = [];
    // let date = moment('2019-11', 'YYYY-MM');
    // for (let i = 0; i < 12; i++) {
    //   date = date.subtract(1, 'month');

    //   const randProcessNum = Math.floor(Math.random() * 30);
    //   const processes = [];
    //   for (let j = 0; j < randProcessNum; j++) {
    //     const randH = Math.floor(Math.random() * 50) + 1;
    //     const randM = Math.floor(Math.random() * 60) + 1;
    //     const randS = Math.floor(Math.random() * 60) + 1;
    //     processes.push({
    //       avgTimePerUnit: `PT${randH}H${randM}M${randS}S`,
    //       preVolume: Math.floor(Math.random() * 200) + 1,
    //       processName: `Process ${j}`,
    //       volume: Math.floor(Math.random() * 200) + 1
    //     });
    //   }
    //   volumes.push({
    //     date: date.format('YYYY-MM'),
    //     processes: processes
    //   });
    // }

    const datesVolumesMap = {};
    this.allProcesses = {};
    this.processTimesSum = {};
    const allDates = volumes.map(d => {
      datesVolumesMap[d.date] = {};
      d.processes.forEach(process => {
        if (this.processTimesSum[process.processName] === undefined) {
          this.processTimesSum[process.processName] = 0;
        }
        if (this.processVolSum[process.processName] === undefined) {
          this.processVolSum[process.processName] = 0;
        }

        const processVaTime = this.valueAddedProcesses.filter((x) => process.processName == x.name).map((p) => p.vaDuration);
        /// TODO: zupełnie bezsensowny quickfix, ale działa.
        /// to można robić np. tylko jeden raz a nie przy każdym "miesiącu" procesu
        /// backend może to od razu wysyłać sam z danymi miesięcznymi - wtedy można po prostu posumować po miesiącach
        /// można matchować po czymś lepszym niż processName
        if(processVaTime[0]) {
          this.processTimesSum[process.processName] = moment.duration(processVaTime[0]).asHours();
        }
        /// END TODO


        this.processVolSum[process.processName] += process.volume;
        this.allProcesses[process.processName] = process;
        datesVolumesMap[d.date][process.processName] = process;
      });
      return moment(d.date, 'YYYY-MM');
    });

    const maxDate = moment.max(allDates);
    const minDate = moment.min(allDates);
    this.datesRanges = [minDate.format('YYYY-MM')];
    const startDate = minDate.clone();
    while (startDate.add(1, 'month').diff(maxDate) <= 0) {
      this.datesRanges.push(startDate.format('YYYY-MM'));
    }

    this.filterData();
    this.datesVolumesMap = datesVolumesMap;
    if (Object.keys(this.selectedRows).length) {
      this.updateLineCharts();
    }

    let volumesData = this.volumes;
    this.$rootScope.dataVolSlicerChart = {
      volumesData
    };
  }

  updateLineCharts() {
    const selectedProcesses = Object.keys(this.selectedRows).filter(x => this.selectedRows[x]);
    const volumes = {selectedProcesses: selectedProcesses};
    const timePerUnit = {selectedProcesses: selectedProcesses};
    this.datesRanges.map(date => {
      if (!volumes[date]) {
        volumes[date] = {value: 0};
      }
      if (!timePerUnit[date]) {
        timePerUnit[date] = {value: 0};
      }

      const dvData = this.datesVolumesMap[date];
      if (dvData) {
        Object.keys(dvData).forEach(key => {
          if (selectedProcesses.includes(key)) {
            volumes[date].value += dvData[key].volume;
            timePerUnit[date].value += moment.duration(dvData[key].avgTimePerUnit).asMilliseconds();
          }
        });
      }
    });

    this.volumesData = Object.assign({}, volumes);
    this.timePerUnitData = Object.assign({}, timePerUnit);
  }

  toggleRow(pName) {
    const currentValue = this.selectedRows[pName];
    Object.keys(this.selectedRows).forEach(key => this.selectedRows[key] = false);
    this.selectedRows[pName] = !currentValue;
    this.updateLineCharts();
    this.$rootScope.selectedRowVolsSlicer = currentValue;
  }

}
